import React, { useEffect, useState } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import BackdropScI from "../../services/BackdropScI";
import { premiA } from "../../Context/InshData";
// import {uri, }  from '../../help/Api';
import { useLocation } from "react-router-dom";
// import {sto,insh} from '../../Context/InshData';
import axios from "axios";
import dataF from "../../Server/dataF.json";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
// import dataF from '../../Server/dataF.json';
import { Apis } from "../../help/Apis";
import MenusContainer from "../Menues/MenusContainer";
import MenusContRef from "../Menues/MenusContRef";
import Swipeable from "./Swipeable";
import { useStylesMain } from "../../St/Fronts/UseStyle";
import { getLS } from "../../utils/useLS";
import POSDashboardCon from "../../comps/Dashboard/POSDashboardCon";
import { GetItemFromOptions } from "../../services/global-services";
import { useHistory } from "react-router-dom";
import moment from "moment";

import { Alert, AlertTitle } from "@material-ui/lab";
import { Snackbar } from "@material-ui/core";
import RePay from "../../Start/RePay";

export function isExpiredAnull(startDate, endDate) {
  // const dateStart = (moment(startDate).format("YYYY-MM-DD"));
  if (startDate == null)
    return true;
  let sdate = moment(new Date());
  const daysTotal = sdate.diff(startDate, 'days');
  return daysTotal >= 380;

  // if (endDate == null) {
  //   if (startDate == null)
  //     return true;
  //   let sdate = moment(new Date());
  //   const daysTotal = sdate.diff(dateStart, 'days');
  //   return daysTotal >= 380;
  // } else {
  //   const dateEnd = (moment(endDate).format("YYYY-MM-DD"));
  //   let sdate = moment(new Date());
  //   const daysTotal = sdate.diff(dateEnd, 'days');
  //   return daysTotal > 15;
  // }
}
export default function Main(props) {
  const { isFromLgin } = props;
  const clas = useStylesMain();
  const loc = useLocation();
  const [permiApp, setPermiApp] = useState({});
  const [showSc, setShowSc] = useState(true);
  const [Users, setUsers] = useState([]);
  const [userData, setUserData] = useState({ id: 0, name: "0" });
  const [found, setFound] = useState({});



  let pScr = getLS("premiScr", {});
  const [uris, setUris] = useState({ uri: "http://localhost:8184/" });
  const [salePointOnly, setSalePointOnly] = useState(
    pScr?.salePointOnly ?? false
  );


  const getUPrmi = async (urisp, stos) => {
    setUserData({ id: stos.idi, name: stos.usernames });
    const tb = {
      wait: true,
      PermissionsScreen1: true,
      PermissionsPointsOfsales: true,
      UsersA: true,
      GetFoundation: true,
      parms: {
        iuserid: stos.idi,
        ibranchid: stos.branchi,
        iempid: stos.empi,
        branch: stos.branchi,
        iFoundid: 1,
      },
      parmsArr: [
        // {
        //   grid:/*sales*/
        //   [
        { iformid: dataF[111].id } /* 0 charts p */,
        { iformid: dataF[47].id } /* 1 sal p */,
        { iformid: dataF[49].id } /* 2 salRet p */,
        { iformid: dataF[46].id } /* 3 purch p */,
        { iformid: dataF[48].id } /* 4 purchRet p */,
        { iformid: dataF[50].id } /* 5 safe p */,
        { iformid: dataF[109].id } /* 6 evrDay eqfDay p */,
        { iformid: dataF[100].id } /* 7 tafseel activ p */,
        { iformid: dataF[88].id } /* 8 safJrd p */,
        { iformid: dataF[38].id } /* 9 custAcc p */,
        { iformid: dataF[76].id } /* 10 acc p */,
        /* BasicData */
        /* T1 */
        { iformid: dataF[0].id } /* 11 found */,
        { iformid: dataF[2].id } /* 12 branch */,
        { iformid: dataF[12].id } /* 13 unit p */,
        { iformid: dataF[3].id } /* 14 item p */,
        { iformid: dataF[102].id } /* 15 itemGroup p */,
        { iformid: dataF[13].id } /* 16 taxGroup */,
        /* T2 */
        { iformid: dataF[2].id } /* 17 safes */,
        { iformid: dataF[5].id } /* 18 stocks */,
        { iformid: dataF[9].id } /* 19 bank */,
        { iformid: dataF[20].id } /* 20 centr */,
        { iformid: dataF[15].id } /* 21 omla */,
        { iformid: dataF[15].id } /* 22 accBook */,
        /* T3 */
        { iformid: dataF[40].id } /* 23 custGroup */,
        { iformid: dataF[43].id } /* 24 salesmen */,
        { iformid: dataF[43].id } /* 25 mokharg */,
        { iformid: dataF[6].id } /* 26 country */,
        { iformid: dataF[7].id } /* 27 city */,
        { iformid: dataF[8].id } /* 28 area */,
        /* T4 */
        { iformid: dataF[41].id } /* 29 mang */,
        { iformid: dataF[42].id } /* 30 dept */,
        { iformid: dataF[43].id } /* 31 job */,
        { iformid: dataF[16].id } /* 32 cardType */,

        { iformid: dataF[59].id } /* 33 salView p */,
        { iformid: dataF[73].id } /* 34 multiQ p */,
        { iformid: dataF[72].id } /* 35 multiS p */,
        { iformid: dataF[66].id } /* 36 sandQKh p */,
        { iformid: dataF[67].id } /* 37 sandSKh p */,
        { iformid: dataF[36].id } /* 38 addCust p */,
        { iformid: dataF[40].id } /* 39 groupCust p */,
        { iformid: dataF[68].id } /* 40 sandQD p */,
        { iformid: dataF[69].id } /* 41 sandSD p */,
        { iformid: dataF[74].id } /* 42 accountTree p */,
        { iformid: dataF[77].id } /* 43 accountRPT p */,
        { iformid: dataF[83].id } /* 44 restInsert p */,
        { iformid: dataF[84].id } /* 45 taxRPT p */,
        { iformid: dataF[39].id } /* 46 custPayTrans p */,
        { iformid: dataF[54].id } /* 47 saleByEmploy p */,
        { iformid: dataF[110].id } /* 48 saleAnalysis p */,
        { iformid: dataF[64].id } /* 49 profitMargin p */,
        { iformid: dataF[53].id } /* 50 saleProfit p */,
        { iformid: "20002" } /* 51 custBalance p */,
      ],
    };

    await axios
      .post(urisp + `Res`, tb)
      .then((res) => {
        console.log("__res__");
        console.log(res.data.permisScr);
        console.log("__res__");
        window.localStorage.setItem(
          "premiScr",
          JSON.stringify(res.data.permisScr)
        );
        setSalePointOnly(res.data.permisScr?.salePointOnly);
        let loc = getLS("premiApp", {});
        setUsers(res?.data?.Users);
        setFound(res?.data?.Found);
        console.log(" the  __users__ is", res?.data?.Users);
        console.log(" def  __users__ is", stos);
        console.log("loc");
        console.log(loc);
        console.log("Maiiiiiiin");
        // alert('stop')
        setPermiApp(loc);
        setShowSc(res.data.wait.state);
        console.log("__res__");
      })
      .catch((error) => { });
  };

  useEffect(() => {
    console.log("premia", premiA);
    const urisR = Apis();
    let loc = getLS("DataRem", {});
    setUris(urisR);
    getUPrmi(urisR, loc);
  }, []);

  //----------------------------------------------------------------
  const locConn = JSON.parse(localStorage.getItem("infoConn")) || {};

  const inshState = {
    server: locConn.server,
    ipinsh: locConn.ipinsh,
    changip: locConn.changip,
    ip: locConn.ip,
    endDigtip: locConn.endDigtip,
    namedb: locConn.namedb,
    id: locConn.id,
    pass: locConn.pass,
    useUri: locConn.useUri,
    port: locConn.port,
    ftp: locConn.ftp,
    typeConnct: locConn.typeConnct,
    mode: locConn.mode,
    leavle: "signIn",
  };

  const refDatas_out = () => {
    localStorage.removeItem("dataShamel");
    let loc = JSON.parse(localStorage.getItem("premiApp"));

    localStorage.setItem("premiApp", JSON.stringify({ ...loc, id: 0 }));
    localStorage.removeItem("DataRem");
  };
  let his = useHistory();

  function refreshPage() {
    his.push({ pathname: "/" });
    window.location.reload(false);
  }

  const singout = () => {
    refDatas_out();
    console.log("swipeable infoconn")
    localStorage.setItem("infoConn", JSON.stringify(inshState));
    refreshPage();
  };
  const DefUsers = Users ? Users : [];
  const valueUsers = GetItemFromOptions(userData?.id, DefUsers);

  useEffect(() => {
    if (valueUsers?.name == null || valueUsers?.name == "") return;
    if (userData?.name != valueUsers?.name) {
      singout();
    };
  }, [Users, userData]);

  const [snack, setSnack] = useState({});
  // useEffect(() => {
  //   let sdate = moment(new Date());
  //   const daysTotal = sdate.diff(found.StartWorkDate, 'days');
  //   console.log("the daysssss total is", daysTotal);
  //   if (daysTotal < 365 && daysTotal >= 335) {
  //   }

  // }, [found, snack]);

  //--------------------------------------------------------------------
  return showSc ? (
    <BackdropScI />
  ) : (
    <React.Fragment>
      <CssBaseline />
      {isExpiredAnull(found?.StartWorkDate??null, found?.EndWorkDate??null) ?
        (
          <RePay  singout={singout}/>
        ) : premiA.menuMin != undefined && premiA.id != 0 ? (
          <React.Fragment>
            {salePointOnly ? (
              <POSDashboardCon />
            ) : (
              <>
                <Container maxWidth="lg">
                  <Typography component="div" className={clas.root}>
                    <MenusContainer />

                    {/* <MenusContRef/> */}
                  </Typography>
                </Container>

                <Typography
                  component="div"
                  style={{
                    marginTop: "2vh",
                    backgroundColor: "#f6f7f9",
                  /*height: '96vh',*/ fontFamily: "Tajawal",
                  }}
                >
                  {/* {riv && <Dtatistics/>} */}
                  <Swipeable />
                </Typography>
              </>
            )}
          </React.Fragment>
        ) : (
          <Container
            maxWidth="lg"
            style={{
              backgroundColor: "#fff",
              height: "100vh",
              paddingTop: "30vh",
            }}
          >
            <MenusContRef />

          </Container>
        )}
    </React.Fragment>
  );
}
